import {
  NumberContainer,
  NumbersContainer,
  NumbersContent,
  NumbersRow
} from "./styles";
import { FC, useState } from "react";
import { MainContainer } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import { CountUp } from "use-count-up";
import { Number } from "../../../models/work";
import { useTranslation } from "next-i18next";
import VisibilitySensor from "react-visibility-sensor";
import Typography from "../../../components/typography";

interface NumbersProps {
  data: Number[];
}

const Numbers: FC<NumbersProps> = ({ data }) => {
  const { i18n: { language } } = useTranslation();
  const [started, setStarted] = useState<boolean>(false);

  const checkState = (isVisible: boolean) => {
    if(isVisible && !started) setStarted(true);
  };

  return (
    <MainContainer>
      <VisibilitySensor onChange={checkState} delayedCall partialVisibility>
        <NumbersContainer>
          <NumbersContent>
            <NumbersRow>
              {
                data.map((number, index) =>
                  <NumberContainer key={index}>
                    <Typography
                      fSize={{ md: 3.688, xxs: 2.188 }}
                      lHeight={{ md: 4.438, xxs: 2.625 }}
                      fWeight={700}
                      style={{ color: colors.black }}
                    >
                      <CountUp
                        isCounting={started}
                        end={number.number}
                        duration={3.0}
                      />
                      {number.symbol && <span>{number.symbol}</span>}
                    </Typography>
                    <Typography
                      fSize={1.125}
                      lHeight={1.5}
                      style={{ color: colors.black }}
                    >
                      {number.title[language]}
                    </Typography>
                  </NumberContainer>
                )
              }
            </NumbersRow>
          </NumbersContent>
        </NumbersContainer>
      </VisibilitySensor>
    </MainContainer>
  );
};

export default Numbers;
